<template>
  <SectionHub section-key="create" class="create-studio" />
</template>

<script>
import SectionHub from '../components/shell/SectionHub.vue'

export default {
  name: 'CreateStudio',
  components: { SectionHub },
}
</script>

<style scoped>
.create-studio {
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 1460px;
  width: 100%;
}
.create-studio :deep(.studio-layout) {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.85fr);
  gap: 16px;
  align-items: start;
}
.create-studio :deep(.studio-layout > *:first-child) {
  grid-column: 1;
  grid-row: 1 / span 40;
}
.create-studio :deep(.studio-layout > *:nth-child(n + 2)) {
  grid-column: 2;
}
/* 顶部说明条（洗稿类）占满一行，下一个块作为左侧主表单 */
.create-studio :deep(.studio-layout > .intro-card) {
  grid-column: 1 / -1;
  grid-row: auto;
}
.create-studio :deep(.studio-layout > .intro-card + *) {
  grid-column: 1;
  grid-row: 2 / span 40;
}

/* 右侧暂无内容（如尚未生成预览）时，主表单独占一行，限制宽度保证可读 */
.create-studio :deep(.studio-layout > *:only-child) {
  grid-column: 1 / -1;
  max-width: 960px;
}

/* 统一所有创作工具的卡片：与全站面板一致的圆角、描边和标题 */
.create-studio :deep(.studio-layout > .el-card),
.create-studio :deep(.studio-layout > .el-tabs) {
  margin: 0;
  border: 1px solid var(--mp-border);
  border-radius: var(--mp-radius-lg);
  box-shadow: none;
  background: var(--mp-surface);
}
.create-studio :deep(.studio-layout > .el-tabs) {
  padding: 4px 16px 16px;
}
.create-studio :deep(.studio-layout > .el-card > .el-card__header) {
  padding: 14px 20px;
  border-bottom-color: var(--mp-border);
}
.create-studio :deep(.studio-layout .card-header) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--mp-text);
}
.create-studio :deep(.studio-layout > .intro-card) {
  background: var(--mp-surface-muted);
}
.create-studio :deep(.studio-layout > .intro-card .el-card__body) {
  padding: 12px 18px;
}
.create-studio :deep(.studio-layout > .intro-card p) {
  font-size: 12px;
  color: var(--mp-text-secondary);
}

@media (max-width: 1100px) {
  .create-studio :deep(.studio-layout) {
    display: flex;
    flex-direction: column;
  }
  .create-studio :deep(.studio-layout > *) {
    grid-column: auto;
    grid-row: auto;
    /* 允许收缩，宽表格在卡片内部横向滚动，而不是把整页撑宽 */
    min-width: 0;
    max-width: 100%;
  }
}

/* 手机：表单标签上置，输入框占满宽度 */
@media (max-width: 768px) {
  .create-studio :deep(.studio-layout .el-form:not(.el-form--inline) .el-form-item) {
    display: block;
  }
  .create-studio :deep(.studio-layout .el-form:not(.el-form--inline) .el-form-item__label) {
    width: auto !important;
    justify-content: flex-start;
    margin-bottom: 4px;
  }
  .create-studio :deep(.studio-layout .el-form:not(.el-form--inline) .el-form-item__content) {
    margin-left: 0 !important;
  }
  .create-studio :deep(.studio-layout .el-card__body) {
    padding: 14px;
  }
  .create-studio :deep(.studio-layout .el-table) {
    max-width: 100%;
  }
}
</style>
